import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe-latest';
import Card from '../../../generic/Card/Card';
import Flex from '../../../generic/Flex';
import { getCurrentPlanType, getSubscriptionPlanDescription, getSubscriptionPlanName, planIcon } from '../utils';
import type { FossaSubscriptionPlan } from '../../../../types';
import { window } from '../../../../globals';
import LimitsComponent, { LimitsComponentForStaticPlan } from '../Limits';
import FeaturesComponent from '../Features';
import { BUSINESS_TIER_FEATURES, ENTERPRISE_TIER_FEATURES, FREE_TIER_FEATURES } from '../../billing/consts';
import styles from '../style.module.less';

type PlanDetailsProps = {
  data: FossaSubscriptionPlan
};
const PlanDetails: VoidFunctionComponent<PlanDetailsProps> = ({
  data,
}) => {
  const org = window?.user?.organization;
  if (!org) {
    return null;
  }

  const icon = planIcon(getCurrentPlanType(org));

  return (

    <Card
      isFullWidth
      isContentFullHeight
      variant="fill"
      padding="none"
    >
      <Card.Content>
        <Flex direction="row" justify="space-between" align="strech" gap={40}>
          <Flex
            direction="column"
            justify="flex-start"
            align="flex-start"
            gap={32}
            className={styles.currentPlanProfileContainer}>
            <img src={icon} alt={data.plan} />
            <DisplayPlanNameAndDescription data={data} />
          </Flex>
          <Flex
            direction="column"
            justify="flex-start"
            align="flex-start"
            grow={2}
            className={styles.currentPlanLimitsContainer}>
            <Flex direction="row" justify="space-between" align="flex-start" gap={20}>
              <DisplayPlanLimitsAndFeatures data={data} />
            </Flex>
          </Flex>
        </Flex>
      </Card.Content>
    </Card>

  );
};

const DisplayPlanNameAndDescription: VoidFunctionComponent<PlanDetailsProps> = ({
  data,
}) => {
  const name = getSubscriptionPlanName(data);
  const description = getSubscriptionPlanDescription(data);

  return (
    <Flex direction="column" gap={8} align="flex-start">
      <div className={styles.currentPlanDetailsName}>{name}</div>
      <div className={styles.currentPlanDetailsDescription}>{description}</div>
    </Flex>
  );
};

const DisplayPlanLimitsAndFeatures: VoidFunctionComponent<PlanDetailsProps> = ({
  data,
}) => {
  if (data.price?.product) {
    return (
      <>
        <LimitsComponent product={data.price.product as Stripe.Product} />
        <FeaturesComponent product={data.price.product as Stripe.Product} />
      </>
    );
  }
  const org = window?.user?.organization;
  if (!org) {
    return null;
  }
  const planType = getCurrentPlanType(org);
  let list: string[] = [] as string[];
  switch (planType) {
    case 'FREE':
      list = FREE_TIER_FEATURES;
      break;
    case 'BUSINESS':
      list = BUSINESS_TIER_FEATURES;
      break;
    case 'ENTERPRISE':
      list = ENTERPRISE_TIER_FEATURES;
      break;
    default:
      break;
  }

  return (<LimitsComponentForStaticPlan list={list} />);
};

export default PlanDetails;
